/** Validate small route queries without shipping a schema library in the shell. */
export function optionalSearchString<Key extends string>(key: Key) {
  return (search: Record<string, unknown>): { [Property in Key]?: string } => {
    const value = search[key];
    if (value === undefined) {
      return {};
    }
    if (typeof value !== "string") {
      throw new Error(`Invalid search parameter: ${key} must be a string.`);
    }
    return { [key]: value } as { [Property in Key]?: string };
  };
}
